import { withQuery } from 'ufo'

export default defineNuxtRouteMiddleware(async (to) => {
  const user = useUser()

  if (!user.value) {
    const redirectTo = to.fullPath ? withQuery('/login', { redirect: to.fullPath }) : '/login'
    return navigateTo(redirectTo, { replace: true })
  }
})
